import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchWattpadRaw = createAsyncThunk(
  "wattpadRawData/fetchWattpadRaw",

  async ({ lte, gte, interval }) => {
    const response = await axiosInstance.request({
      url: `wattpad/raw`,
      method: `GET`,
      params: {
        lte,
        gte,
        interval,
      },
    });
    return response;
  }
);

const wattpadRawDataSlice = createSlice({
  name: "wattpadRawData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchWattpadRaw.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWattpadRaw.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchWattpadRaw.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const WattpadRawDataReducer = wattpadRawDataSlice.reducer;

export default WattpadRawDataReducer;

export const wattpadRawDataAction = wattpadRawDataSlice.actions;
